import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AdminAuditLogs = () => {
  const auditLogs = [
    {
      dateTime: '2024-06-10 16:32',
      user: {
        name: 'Dr. Sarah Wilson',
        email: 'sarah.wilson@example.com',
        avatar: 'https://i.pravatar.cc/150?img=1'
      },
      action: 'LOGIN_SUCCESS',
      actionColor: 'green',
      resourceType: 'session',
      resourceId: 'sess_28h9wh25634',
      ipAddress: '192.168.1.14',
      deviceInfo: 'Chrome on Windows',
      details: 'View'
    },
    {
      dateTime: '2024-06-10 14:18',
      user: {
        name: 'John Smith',
        email: 'john.smith@healthcare.com',
        avatar: 'https://i.pravatar.cc/150?img=2'
      },
      action: 'PRESCRIPTION_DELETE',
      actionColor: 'red',
      resourceType: 'prescription',
      resourceId: 'presc_232409789',
      ipAddress: '192.168.1.55',
      deviceInfo: 'Firefox on Windows',
      details: 'View'
    },
    {
      dateTime: '2024-06-10 16:25',
      user: {
        name: 'Emma Davis',
        email: 'emma.davis@healthcare.com',
        avatar: 'https://i.pravatar.cc/150?img=3'
      },
      action: 'VIEW_RECORD',
      actionColor: 'blue',
      resourceType: 'assessment',
      resourceId: 'asses_123456789',
      ipAddress: '192.168.1.36',
      deviceInfo: 'Safari on iOS',
      details: 'View'
    },
    {
      dateTime: '2024-06-09 12:45',
      user: {
        name: 'Dr. Michael Chen',
        email: 'm.chen@healthcare.com',
        avatar: 'https://i.pravatar.cc/150?img=4'
      },
      action: 'PATIENT_UPDATE',
      actionColor: 'orange',
      resourceType: 'patient',
      resourceId: 'pat_987654321',
      ipAddress: '192.168.1.22',
      deviceInfo: 'Chrome on macOS',
      details: 'View'
    },
    {
      dateTime: '2024-06-09 09:30',
      user: {
        name: 'Lisa Anderson',
        email: 'l.anderson@healthcare.com',
        avatar: 'https://i.pravatar.cc/150?img=5'
      },
      action: 'DATA_EXPORT',
      actionColor: 'purple',
      resourceType: 'report',
      resourceId: 'rep_445566778',
      ipAddress: '192.168.1.88',
      deviceInfo: 'Chrome on Windows',
      details: 'View'
    }
  ];

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const formatDateTime = (datetimeStr) => {
    const isoStr = datetimeStr.replace(' ', 'T');
    const date = new Date(isoStr);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', ' at');
  };

  const getActionColor = (color) => {
    switch (color) {
      case 'green': return 'bg-green-100 text-green-800';
      case 'red': return 'bg-red-100 text-red-800';
      case 'blue': return 'bg-blue-100 text-blue-800';
      case 'orange': return 'bg-orange-100 text-orange-800';
      case 'purple': return 'bg-purple-100 text-purple-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const filteredLogs = auditLogs.filter((log) => {
    if (startDate && endDate) {
      const logDate = new Date(log.dateTime.replace(' ', 'T'));
      return logDate >= startDate && logDate <= endDate;
    }
    return true;
  });

  return (
    <div className="min-h-screen">
      <div className="mb-6 md:mb-8">
        <h1 className="text-xl md:text-2xl font-semibold text-gray-800">Audit Logs</h1>
        <p className="text-gray-600 mt-2">Keep an eye on important account activity and system changes, all in one place.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div>
          <div className="relative">
            <input
              type="text"
              placeholder="Search by user, email, or IP"
              className="w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>
        </div>

        <div>
          <div className="relative max-w-[250px] w-full">
            <DatePicker
              selectsRange
              startDate={startDate}
              endDate={endDate}
              onChange={(update) => setDateRange(update)}
              placeholderText="Select date range"
              className="w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              isClearable
              dateFormat="MMM dd, yyyy"
            />
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
        </div>

        <div>
          <div className="relative w-full">
            <select className="appearance-none w-full text-sm border border-gray-200 rounded-lg py-2 px-4 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>All Actions</option>
              <option>LOGIN_SUCCESS</option>
              <option>LOGIN_FAILED</option>
              <option>VIEW_RECORD</option>
              <option>UPDATE_RECORD</option>
              <option>DELETE_RECORD</option>
              <option>DATA_EXPORT</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
              <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div>
          <div className="relative w-full">
            <select className="appearance-none w-full text-sm border border-gray-200 rounded-lg py-2 px-4 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>All Types</option>
              <option>session</option>
              <option>patient</option>
              <option>prescription</option>
              <option>assessment</option>
              <option>report</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
              <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="space-y-1">
        <div className="py-4">
          <div className="hidden md:grid grid-cols-12 gap-4 items-center text-xs font-medium text-gray-600 uppercase tracking-wider text-left bg-gray-100 p-4 rounded-lg">
            <div className="col-span-2">User</div>
            <div className="col-span-2">Action</div>
            <div className="col-span-1">Resource</div>
            <div className="col-span-2">Date</div>
            <div className="col-span-2">Resource ID</div>
            <div className="col-span-2">IP Address</div>
            <div className="col-span-1">Details</div>
          </div>
        </div>

        <div className="space-y-2">
          {filteredLogs.map((log, index) => (
            <div key={index} className="rounded-xl border transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md bg-white border-gray-200 hover:border-blue-300 hover:bg-blue-50">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-start md:items-center px-4 md:px-6 py-4 text-sm">
                <div className="md:col-span-2 flex items-center">
                  <img className="h-10 w-10 rounded-full object-cover mr-3 border-2 border-gray-200" src={log.user.avatar} alt={log.user.name} />
                  <div>
                    <div className="font-medium text-gray-900">{log.user.name}</div>
                    <div className="text-xs text-gray-500">{log.user.email}</div>
                  </div>
                </div>
                <div className="md:col-span-2">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getActionColor(log.actionColor)}`}>
                    {log.action}
                  </span>
                </div>
                <div className="md:col-span-1 text-gray-600">{log.resourceType}</div>
                <div className="md:col-span-2 text-gray-600">{formatDateTime(log.dateTime)}</div>
                <div className="md:col-span-2 font-mono text-gray-600 break-all">{log.resourceId}</div>
                <div className="md:col-span-2 text-gray-600">{log.ipAddress}<div className="text-xs text-gray-500">{log.deviceInfo}</div></div>
                <div className="md:col-span-1">
                  <button className="text-blue-600 hover:text-blue-800 font-medium">{log.details}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pagination Footer */}
      <div className="bg-white border-t border-gray-200 px-4 py-3 flex items-center justify-between">
        <p className="text-sm text-gray-700">Showing 1 to 5 of 234 results</p>
        <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
          <button className="px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm text-gray-500 hover:bg-gray-50">
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" /></svg>
          </button>
          <button className="px-4 py-2 border border-gray-300 bg-white text-sm text-gray-700">1</button>
          <button className="px-4 py-2 border border-gray-300 bg-white text-sm text-gray-700">2</button>
          <button className="px-4 py-2 border border-gray-300 bg-white text-sm text-gray-700">3</button>
          <button className="px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm text-gray-500 hover:bg-gray-50">
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" /></svg>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default AdminAuditLogs;
